export var ANALYTICS_CHANNEL = 'media';
export var COMPONENT_NAME = 'linkPicker';
export var RECENT_SEARCH_LIST_SIZE = 5;
export var LINK_PICKER_WIDTH_IN_PX = 342;
export var LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK = '290px';